import React, { useState } from "react";
//outsource
import { Row, Col, InputNumber, Form } from "antd";

//components

const IncomeCash = ({ edit, cash, setCash }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION ------------------------
  const handleChange = (value) => {
    setCash(value);
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item initialValue={0} name="cash">
      <InputNumber
        min={0}
        value={cash}
        onChange={handleChange}
        prefix="$"
        disabled={!edit}
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      />
    </Form.Item>
  );
};

export default IncomeCash;
